/**
 * User: Rob Richard
 * Date: 9/19/14
 * Time: 10:33 AM
 */

'use strict';

const { localStorage } = require('dibs-browser-storage');
const { STORAGE } = require('../utils/checkoutStorageConstants');

export default {
    clearPreAuthOfferModalInfo() {
        return localStorage.deleteItem('checkoutPreAuthOfferModalInfo');
    },
    unsetAutoModalInfo() {
        localStorage.deleteItem(STORAGE.AUTO_MODAL_INFO);
    },
    unsetSurveyInfo() {
        return localStorage.deleteItem(STORAGE.SURVEY_INFO);
    }
};



// WEBPACK FOOTER //
// ./src/abandonedCheckout/checkoutStorage.js